
import * as defaultImport from "lodash/isFunction";
export * from "lodash/isFunction";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
